import { motion } from "framer-motion";
import { useMediaQuery } from "react-responsive";

export const SectionThree = () => {

  const cardsData1 = [
    {
      profile: "assets/images/kwikcheckoutcod/testimonial-profile-1.png",
      logo: "assets/images/kwikcheckoutcod/testimonial-logo-1.png",
      name: "Siddharth Darda, Founder, Tistabene",
      title: "84.6% increase in pre paid conversions",
      message:
        "With GoKwik onboard, our prepaid orders increased from 13% to 24% and significantly reduced RTO rate. Our checkout conversions have also doubled.",
    },
    {
      profile: "assets/images/kwikcheckoutcod/testimonial-profile-2.png",
      logo: "assets/images/kwikcheckoutcod/testimonial-logo-2.png",
      name: "Rahul Anand, Founder & CEO, Hopscotch",
      title: "Reduced COD RTO by 12.6%.",
      message:
        "With GoKwik's Smart COD Suite, our RTO reduced significantly and pin code serviceability increased by almost 26%.",
    },
    {
      profile: "assets/images/kwikcheckoutcod/testimonial-profile-3.png",
      logo: "assets/images/kwikcheckoutcod/testimonial-logo-3.png",
      name: "Hitesh Dhingra, Founder & Managing Director, TMC",
      title: "25% increase in checkout conversions",
      message:
        "The GoKwik team has a single minded focus on conversion rates. Within a short span of time, GoKwik helped us uplift our conversion rates and increase our prepaid transactions.",
    },
  ];

  const cardsData2 = [
    {
      profile: "assets/images/kwikcheckoutcod/testimonial-profile-4.png",
      logo: "assets/images/kwikcheckoutcod/testimonial-logo-4.png",
      name: "Pritish Vartak, AGM, Growth Marketing, Pilgrim",
      title: "Clocks 75K+ Orders, ~92% More Than Its Previous Flash Sale!",
      message:
        "Thanks to KwikCheckout, our Pilgrim’s Birthday Flash Sale went smoothly. We clocked in about 75000+ orders in 5 days, almost double the numbers as compared to our April Flash Sale. Thanks to the GoKwik team",
    },
    {
      profile: "assets/images/kwikcheckoutcod/testimonial-profile-5.png",
      logo: "assets/images/kwikcheckoutcod/testimonial-logo-5.png",
      name: "Taran Chhabra, Co-founder, Neeman's",
      title: "Increased Prepaid Transactions By 30%",
      message:
        "Thanks to GoKwik's KwikCheckout, we were successfully able to increase our prepraid conversion share by 30%. Not only this, our RTO was reduced from 22.44% to 9.93% in just 4 months!",
    },
    {
      profile: "assets/images/kwikcheckoutcod/testimonial-profile-6.png",
      logo: "assets/images/kwikcheckoutcod/testimonial-logo-6.png",
      name: "Kapil Gupta, Founder, Ruhe India",
      title: "40.41% Increase In Checkout Conversions",
      message:
        "With GoKwik onboard, our prepaid orders increased from 13% to 24% and significantly reduced RTO rate. Our checkout conversions have also doubled.",
    },
  ];

  const scrollRow = {
    animate: {
      x: ['0%', '-100%'],
      transition: {
        x: {
          repeat: Infinity,
          repeatType: 'loop',
          duration: 25,
          ease: 'linear',
        },
      },
    },
  };

  const scrollRowReverse = {
    animate: {
      x: ['-100%', '0%'],
      transition: {
        x: {
          repeat: Infinity,
          repeatType: 'loop',
          duration: 25,
          ease: 'linear',
        },
      },
    },
  };


  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <div className="section-three" style={{ padding: isMobile && "0 20px" }}>
      <div className="headline">
        <h1 style={{ fontWeight: "700" }}>Our merchants have greatly benefited from our partnership</h1>
        <p style={{ fontSize: "20px", fontWeight: "300" }}>Their words, not ours</p>
      </div>

      <div className="testimonials-container-outer">
        <motion.div
          className="testimonials-container-row slider-track-three"
          variants={scrollRow}
          animate="animate"
        >
          {cardsData1.concat(cardsData1).map((data, index) => ( // duplicated for smooth infinite
            <div className="testimonial-card" key={index}>
              <div className="brand-info">
                <div className="profile-info">
                  <span className="profile-image">
                    <img src={data.profile} alt={data.name} />
                  </span>
                  <p>{data.name}</p>
                </div>
                <img src={data.logo} alt={data.name} />
              </div>
              <h6>{data.title}</h6>
              <p className="testimonial-message">{data.message}</p>
            </div>
          ))}
        </motion.div>
      </div>

      <div className="testimonials-container-outer">
        <motion.div
          className="testimonials-container-row slider-track-three"
          variants={scrollRowReverse}
          animate="animate"
        >
          {cardsData2.concat(cardsData2).map((data, index) => ( // duplicated for smooth infinite
            <div className="testimonial-card" key={index}>
              <div className="brand-info">
                <div className="profile-info">
                  <span className="profile-image">
                    <img src={data.profile} alt={data.name} />
                  </span>
                  <p>{data.name}</p>
                </div>
                <img src={data.logo} alt={data.name} />
              </div>
              <h6>{data.title}</h6>
              <p className="testimonial-message">{data.message}</p>
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};
